import React from "react";
import styles from "../Login.module.css";
import { FaGoogle } from "react-icons/fa";
import { useAuth } from "../AuthHooks";
import Loading from "../../Loading";

const Social = () => {
  const { loginGoogle, loading } = useAuth();

  if (loading) {
    return <Loading top={true} />;
  }

  return (
    <button
      onClick={loginGoogle}
      className={styles.submit + " " + styles.google}
    >
      <FaGoogle />
      <span>Continue With Google</span>
    </button>
  );
};

export default Social;
